const zIndices = {
  fullScreenLoadingState: 48,
  headerNav: 49,
  appLoadingIndicator: 50,
  tableRowActive: 7,
  tableTBodyTh: 8,
  tableRowHover: 9,
  tableRowFocus: 10,
  tableThead: 11,
  tableTHeadTh: 12,
  tableDeveloper: 20,
  popoverOverlay: 50,
  portal: 60,
  sidebarTrigger: 51,
  sidebarOverlay: 52,
  sidebarBody: 53,
  sidebarToggle: 54,
};

export default zIndices;
